import Component from '../../../../../ui-components/Component';
import { withResizer, withTranslations } from '../../../../../HoCs';
import view from '../../../../../Enums';
import { secondary, secondaryOutline } from '../../../../../resources/styles';
import stageMap from '../../config';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import React from 'react';
import Styles from './styles';
import { path } from '../../../../../utils';

class Tab extends Component{
    
    styles=Styles
    
    isComplete = () => path(this.props.element,'section_state',-1) === 'complete'
    
    render = () => {
        return <React.Fragment>
        <div style={{
            ...this.gs('title_flex_element'),
            ...((this.props.isSelected && this.getViewMode()!= view.MOBILE)?{boxShadow: `inset 0px -2px 0px ${secondary.color}`}:{})
        }} className='hover' onClick={this.props.onClick} >
            <div style={{marginLeft:this.props.marginLeft,marginRight:this.props.marginRight,...this.gs('title_flex_element_child')}}>
                <div style={{position:'relative'}}>
                    {this.isComplete() && <CheckCircleIcon style={this.gs('circle_icon')}/>}
                    {stageMap[this.props.element.section_type].getIcon({
                        ...this.gs('icon'),
                        ...((this.props.isSelected)?{background:'rgba(34, 152, 218, 0.08)',...secondary,border:`1px solid ${secondaryOutline.color}`}:{})
                    })}
                </div>
                <div style={this.gs('title_child_text_container')}>
                    <div style={{...this.gs('title_slider_step'),...(this.props.isSelected?secondary:{})}}>{((this.getViewMode() != view.MOBILE || this.props.isSelected)?this.props.gc('STEP')+" ":"")+(this.props.idx+1)}</div>
                    {this.getViewMode()!= view.MOBILE && <div style={{...this.gs('title_slider_content'),...(this.props.isSelected?secondary:{})}}>{stageMap[this.props.element.section_type]['translation']}</div>}
                </div>
            </div>
        </div>
        {this.props.renderLine &&
            <div style={this.gs('line')}></div>
        }
    </React.Fragment>
    }
}

export default withTranslations(withResizer(Tab))